var _defs, _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFreecharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f57450;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256,
    cy: 256,
    r: 240
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M312.42,137.5c8.15-.19,16.28,1.02,24.03,3.57l9.28-41.89c-10.36-2.4-21-3.45-31.63-3.12-46,0-73.67,19.08-85.08,60.83-6.77,24.94-6.84,34.9-24.71,35.35h-15.66l-5.4,39.69h39.23l-51.09,100.44h37.48l-42.58,83.63,116.18-120.66h-43.72l74.74-74.51,5.32-28.89h-45.62l2.28-16.8c3.57-26.31,15.21-38.02,37.03-38.02"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreecharge);
export default __webpack_public_path__ + "static/media/freecharge.ce78f2f2cc82e0878adfba0429f58f33.svg";
export { ForwardRef as ReactComponent };